import React, {useState, useEffect} from 'react';
import axios from 'axios';
import Item from './Item';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';
import Grid from '@material-ui/core/Grid';
import ItemDesc from './ItemDesc';
import Waiting from './Waiting';

const server = 'https://infinite-dusk-89390.herokuapp.com';
// '4': [5, 88], '164': [66, 3543]
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: '15px',
  },
  slider: {
    textAlign: 'center',
    color: 'white',
    width: 300,
    margin: 'auto',
  },
}));

export default ({
  size,
  user,
  searchVal,
  toggles,
  setTotal,
  sendSave,
  confirmSave,
}) => {
  const classes = useStyles();
  const [showItem, setShowItem] = useState(-1);
  const [items, setItems] = useState([]);
  const [counts, setCounts] = useState({});
  const [value, setValue] = React.useState([10, 15]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const updateCounts = (id, inc) => {
    const copied = JSON.parse(JSON.stringify(counts));
    copied[id] = copied[id] ? Math.max(copied[id] + inc, 0) : Math.max(inc, 0);
    setCounts(copied);
  };

  const bagValues = {
    'brown bag': 0,
    'pink bag': 1,
    'purple bag': 2,
    'egg basket': 3,
    'cyan bag': 5,
    'blue bag': 6,
    'white bag': 9,
    'golden bag': 4,
    'orange bag': 7,
    'red bag': 8,
  };
  const itemComp = (a, b) => {
    const comp = (a, b) => {
      if (a < b) return -1;
      if (a > b) return 1;
      return 0;
    };

    // if (Object.keys(counts).length > 0)
    //   return -1 * comp(counts[a.id], counts[b.id]);
    console.log();
    return (
      10000 * comp(bagValues[b.bag], bagValues[a.bag]) +
      1000 * comp(b.tier, a.tier) +
      100 * comp(a.slot, b.slot) +
      10 * comp(a.name, b.name) +
      comp(a.description, b.description)
    );
  };

  useEffect(() => {
    console.log('getting items');
    axios.get(`${server}/getEquipment`).then((res) => {
      setItems(res.data);
    });

    if (user) {
      console.log('getting counts');
      axios
        .post(`${server}/getDrops`, {id: user.uid.toString()})
        .then((res) => {
          setCounts(res.data);
        });
    }
  }, [user]);

  useEffect(() => {
    if (sendSave) {
      axios.post(`${server}/updateDrops`, {
        id: user.uid.toString(),
        newCount: counts,
      });
      console.log('saved');
      confirmSave();
    }
  });

  useEffect(() => {
    let total = 0;
    for (const key in counts) {
      if (counts.hasOwnProperty(key)) {
        total += counts[key];
      }
    }
    setTotal(total);
  });

  const maxTier = Math.max.apply(
    Math,
    items.map((o) => {
      return o.tier;
    })
  );

  const getItem = (item) => (
    <Grid item key={item.id}>
      <Item
        key={item.id}
        {...item}
        showItem={showItem}
        setShowItem={setShowItem}
        count={counts[item.id] || 0}
        setCount={updateCounts}
      />
    </Grid>
  );

  let showList = items
    .filter(
      (item) =>
        item.bag.toLowerCase().includes(searchVal.toLowerCase()) ||
        item.name.toLowerCase().includes(searchVal.toLowerCase()) ||
        item.slot.toLowerCase().includes(searchVal.toLowerCase()) ||
        item.description.toLowerCase().includes(searchVal.toLowerCase())
    )
    .sort(itemComp);

  if (toggles.got === 1)
    showList = showList.filter(
      (x) => counts[x.id] !== undefined && counts[x.id] > 0
    );
  if (toggles.got === 2)
    showList = showList.filter(
      (x) => counts[x.id] === undefined || counts[x.id] === 0
    );
  if (toggles.sb === 1) showList = showList.filter((x) => x.soulbound);
  if (toggles.sb === 2) showList = showList.filter((x) => !x.soulbound);
  if (toggles.tier === 1) showList = showList.filter((x) => x.tier !== -1);
  if (toggles.tier === 2) showList = showList.filter((x) => x.tier === -1);

  showList = showList.filter((item) => {
    if (item.tier === -1) return true;
    if (item.slot === 'ring') return item.tier * 2 >= value[0];
    return item.tier >= value[0] && item.tier <= value[1];
  });
  const sliderHeight = size.width < 688 ? '35px' : '0px';
  return (
    <div
      className={classes.root}
      style={{
        minHeight: `${size.height - 130}px`,
        backgroundColor: '#011627',
      }}
    >
      <div className={classes.slider}>
        <Typography
          id="range-slider"
          gutterBottom
          style={{paddingTop: sliderHeight}}
        >
          Tier Range (ring tier &times; 2)
        </Typography>
        <Slider
          value={value}
          onChange={handleChange}
          valueLabelDisplay="auto"
          aria-labelledby="range-slider"
          min={0}
          max={maxTier}
        />
      </div>
      {showItem !== -1 && (
        <ItemDesc
          {...items.find((x) => x.id === showItem)}
          showItem={showItem}
          callback={setShowItem}
        />
      )}
      {!user && (
        <p style={{color: 'white', marginTop: '0px', textAlign: 'center'}}>
          Hint: sign in to save your drop counts.
        </p>
      )}
      {items.length == 0 && <Waiting />}
      <Grid
        container
        direction="row"
        alignItems="flex-start"
        justify="flex-start"
        style={{
          marginLeft: 'auto',
          marginRight: 'auto',
          width: `${Math.floor((size.width - 49) / 116) * 116 + 4}px`,
        }}
        spacing={2}
      >
        {showList.map(getItem)}
      </Grid>
    </div>
  );
};
